<template>
  <FloatingPanel 
    v-if="(senhasTotemPendente.length) && rotaPermitida()" 
    title="Senhas para chamar" 
    subtitle="Senhas aguardando para serem chamadas" 
    :badge="filtraSenhasTotemPendente.filter(s => (!s.CHAMADA_POR || s.CHAMADA_POR == usuario)).length" 
    :collapsed="collapsed" 
    :closable="closable" 
    :position-index="positionIndex" 
    :width="410" 
    :max-body-height="480" 
    @update:collapsed="collapsed = $event" 
    @close="$emit('close')"
  >
    <template #icon>
      <svg 
        viewBox="0 0 24 24" 
        fill="none" 
        aria-hidden="true"
      >
        <path 
          d="M7 3H14L19 8V20C19 20.6 18.6 21 18 21H7C6.4 21 6 20.6 6 20V4C6 3.4 6.4 3 7 3Z" 
          stroke="currentColor" 
          stroke-width="1.8" 
          stroke-linejoin="round"
        />

        <path 
          d="M14 3V8H19" 
          stroke="currentColor" 
          stroke-width="1.8" 
          stroke-linejoin="round"
        />

        <path 
          d="M9 15L11 17L15.5 12.5" 
          stroke="currentColor" 
          stroke-width="1.8" 
          stroke-linecap="round" 
          stroke-linejoin="round"
        />
      </svg>
    </template>

    <template #header-actions>
      <button 
        v-if="showRefresh"
        type="button"
        class="refresh-button"
        :class="{
          'refresh-button--loading': loading
        }"
        aria-label="Atualizar documentos"
        :disabled="loading"
        @click="refresh"
      >
        <svg 
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path 
            d="M20 7V12H15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />

          <path 
            d="M19 12C18.5 8.7 15.6 6 12 6C8.1 6 5 9.1 5 13C5 16.9 8.1 20 12 20C14.6 20 16.9 18.6 18.1 16.5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </template>

    <button 
      type="button" 
      class="btn btn-block btn-primary" 
      style="font-size: 11px; width: calc(100% - 8px); padding: 4px; margin: 4px;" 
      @click="informarLocalizacaoFisica"
    >
      {{ localizacaoFisica ? localizacaoFisica : "Informe o nome do seu local" }}
    </button>

    <div style="width: calc(100% - 8px); padding: 4px; margin: 4px; text-align: center;">
      <InputCheckbox 
        v-for="fila in filasSenhasTotemPendente" 
        :key="fila.nome" 
        :label="fila.nome" 
        :value="fila.marcado" 
        tamanho="usm" 
        style="margin-right: 16px;" 
        @click="toggleFila(fila.nome)"
      />
    </div>
    <div style="width: calc(100% - 8px); padding: 4px; margin: 4px; text-align: center; background-color: white; border-radius: 4px;;">
      <InputSelect 
        :nolabel="true" 
        v-model="tvChamada" 
        :items="opcoesTVs" 
        style="margin-bottom: 0px !important;"
      />
    </div>

    <!-- Loading -->
    <div
      v-if="loading && !senhasTotemPendente.length"
      class="panel-state"
    >
      <div class="spinner" />

      <span>
        Buscando senhas...
      </span>
    </div>

    <!-- Sem senhas -->
    <div 
      v-else-if="!senhasTotemPendente.length"
      class="panel-state panel-state--empty"
    >
      <div class="empty-icon">
        <svg 
          viewBox="0 0 32 32" 
          fill="none" 
          aria-hidden="true"
        >
          <circle 
            cx="16" 
            cy="16" 
            r="13" 
            stroke="currentColor" 
            stroke-width="2"
          />

          <path
            d="M10.5 16L14 19.5L21.5 12" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <strong>Nenhuma senha pendente</strong>

      <span>
        As novas senhas aparecerão aqui quando
        estiverem prontas para serem chamadas.
      </span>
    </div>

    <!-- Senhas -->
    <div
      v-else
      class="documents"
    >
      <article
        v-for="senhaTotemPendente in filtraSenhasTotemPendente.filter(s => (!s.CHAMADA_POR || s.CHAMADA_POR == usuario))" 
        :key="senhaTotemPendente.ID_TOTEM_SENHA" 
        class="document-item"
      >
        <div class="document-item__top">
          <div class="document-item__icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M7 3H14L19 8V20C19 20.6 18.6 21 18 21H7C6.4 21 6 20.6 6 20V4C6 3.4 6.4 3 7 3Z"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linejoin="round"
              />

              <path
                d="M14 3V8H19"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linejoin="round"
              />

              <path
                d="M9 12H16M9 15H15"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
              />
            </svg>
          </div>

          <div class="document-item__content">
            <div class="document-item__title">
              {{ senhaTotemPendente.SENHA }}
            </div>

            <div
              v-if="senhaTotemPendente.PACIENTE"
              class="document-item__patient"
            >
              {{ senhaTotemPendente.PACIENTE }}
            </div>
            <div
              v-if="senhaTotemPendente.HORARIOS_AGENDADOS && senhaTotemPendente.HORARIOS_AGENDADOS.length"
              class="document-item__appointment"
            >
              Agendado hoje: {{ senhaTotemPendente.HORARIOS_AGENDADOS.join(', ') }}
            </div>
          </div>

          <!--<span
            class="document-item__type"
          >
            item.type
          </span>-->
          <span
            class="document-item__type"
          >
            Senha
          </span>
        </div>

        <div 
          v-if="senhaTotemPendente.DATA_INCLUSAO || senhaTotemPendente.CHAMADA_POR" 
          class="document-item__metadata"
        >
          <span 
            v-if="senhaTotemPendente.DATA_INCLUSAO" 
            class="document-item__date"
          >
            Chegada: {{ formatDate(senhaTotemPendente.DATA_INCLUSAO) }}<br v-if="senhaTotemPendente.CHAMADA_DATA" />
            <span v-if="senhaTotemPendente.CHAMADA_DATA">Chamada: {{ formatDate(senhaTotemPendente.CHAMADA_DATA) }}</span>
          </span>
          <span 
            v-if="senhaTotemPendente.CHAMADA_POR" 
            class="badge badge-primary document-item__date" 
            style="font-size: 9px;"
          >
            Chamada Por: {{ senhaTotemPendente.CHAMADA_POR }}
          </span>
          <span 
            v-if="senhaTotemPendente.CHAMADA_LOCALIZACAO_FISICA" 
            class="badge badge-primary document-item__date" 
            style="font-size: 9px;"
          >
            Local: {{ senhaTotemPendente.CHAMADA_LOCALIZACAO_FISICA }}
          </span>
        </div>

        <div class="document-item__actions">
          <button
            type="button"
            class="action-button action-button--discard"
            :disabled="isItemBusy(senhaTotemPendente)"
            @click="descartar(senhaTotemPendente)"
          >
            <svg 
              viewBox="0 0 20 20" 
              fill="none" 
              aria-hidden="true"
            >
              <path
                d="M4 6H16M8 6V4H12V6M6 6L7 16H13L14 6"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            Descartar
          </button>

          <button
            type="button"
            class="action-button action-button--sign"
            :disabled="isItemBusy(senhaTotemPendente)"
            @click="chamar(senhaTotemPendente)"
          >
            <span
              v-if="senhaTotemPendente.chamando"
              class="button-spinner"
            />

            <svg 
              v-else 
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <!-- Corpo do megafone -->
              <path
                d="M4.5 8V12H7L13.5 15V5L7 8H4.5Z"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linejoin="round"
              />

              <!-- Cabo -->
              <path
                d="M7 12L8 16H10L9 12"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linejoin="round"
                stroke-linecap="round"
              />

              <!-- Ondas sonoras -->
              <path
                d="M15.5 7C16.2 7.7 16.5 8.7 16.5 10C16.5 11.3 16.2 12.3 15.5 13"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />

              <path
                d="M17.5 5.5C18.5 6.7 19 8.2 19 10C19 11.8 18.5 13.3 17.5 14.5"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />
            </svg>

            {{ senhaTotemPendente.chamando ? 'Chamando...' : 'Chamar' }}
          </button>
        </div>
      </article>
    </div>

    <template
      v-if="senhasTotemPendente.length"
      #footer
    >
      <div class="panel-footer">
        <span>
          {{ filtraSenhasTotemPendente.filter(s => (!s.CHAMADA_POR || s.CHAMADA_POR == usuario)).length }}
          {{ filtraSenhasTotemPendente.filter(s => (!s.CHAMADA_POR || s.CHAMADA_POR == usuario)).length === 1 ? 'senha pendente' : 'senhas pendentes' }}
        </span>

        <span
          v-if="loading"
          class="panel-footer__sync"
        >
          Atualizando...
        </span>
      </div>
    </template>
  </FloatingPanel>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import JwtService from "@/core/services/jwt.service";

import InputCheckbox from "@/../../desk-spirit/src/components/inputs/InputCheckbox.vue";
import InputSelect from "@/../../desk-spirit/src/components/inputs/InputSelect.vue";
import FloatingPanel from "@/../../desk-spirit/src/components/FloatingPanel.vue";

export default {
  name: "SenhasTotemPanel", 
  components: {
    InputCheckbox, 
    InputSelect, 
    FloatingPanel
  }, 
  data() {
    return {
      checkSenhasTotemPendente: null, 
      collapsed: true, 
      loading: false, 
      opcoesFilas: [], 
      tvChamada: JwtService.criarObterGenerico("tvChamadaSenhasTotemPanel", ""), 
      opcoesTVs: [], 
      visualizaFilaEsperaTotem: false
    };
  }, 
  props: {
    closable: {
      type: Boolean, 
      default: false
    }, 
    showRefresh: {
      type: Boolean, 
      default: true
    }, 
    positionIndex: {
      type: Number, 
      default: 0
    }
  }, 
  emits: [
    "sign", 
    "discard", 
    "refresh", 
    "close"
  ], 
  async mounted() {
    while(this.loadingUserInfo) {
      await this.sleepTime(100);
    }

    await this.buscarConfiguracoes();

    if(this.visualizaFilaEsperaTotem) {
      this.startTimer();
    }
  }, 
  beforeUnmount() {
    this.clearTimer();
  }, 
  computed: {
    ...mapGetters([
      "loadingUserInfo", 
      "idEmitenteML", 
      "usuario", 
      "localizacaoFisica", 
      "senhasTotemPendente", 
      "filasSenhasTotemPendente", 
      "filtraSenhasTotemPendente"
    ])
  }, 
  watch: {
    async tvChamada() {
      await this.$nextTick();

      JwtService.salvarGenerico("tvChamadaSenhasTotemPanel", this.tvChamada);
    }, 
  }, 
  methods: {
    ...mapActions([
      "atualizarLocalizacaoFisica", 
      "verificarSenhasTotemPendente", 
      "atualizarSenhaChamando", 
      "atualizarSenhaDescartando", 
      "chamarSenhaTotemPendente", 
      "descartarSenhaTotemPendente", 
      "selecionarFilaSenhaTotem", 
      "getConfiguracoesMasterMultiplas", 
      "sleepTime"
    ]), 
    async informarLocalizacaoFisica() {
      const resposta = await this.$swal({
        title: "Descreva o nome do seu local:", 
        input: "text", 
        showLoaderOnConfirm: false, 
        inputValidator: (value) => {
          if(!value) {
            return "Você precisa digitar o nome do seu local!";
          }
        }
      });

      if((resposta.isConfirmed) && (resposta.value)) {
        this.atualizarLocalizacaoFisica(resposta.value);
      }
    }, 
    async buscarConfiguracoes() {
      this.opcoesTVs = [];

      let configuracoes = await this.getConfiguracoesMasterMultiplas([{
        CONTEUDO_NOME: "TEXTO", 
        NIVEL: "1", 
        OPERACAO: "C", 
        USUARIO: "GERAL", 
        SISTEMA: "CLMADV", 
        MODULO: "CHAMADA_TV", 
        CAMPO: "USUARIOS_CHAMADA_TV", 
        CONTEUDO: ""
      },{
        CONTEUDO_NOME: "CONTEUDO", 
        NIVEL: "4", 
        OPERACAO: "C", 
        USUARIO: this.usuario, 
        SISTEMA: "CLMADV", 
        MODULO: "TOTEM", 
        CAMPO: "VISUALIZA_FILA_ESPERA_TOTEM", 
        CONTEUDO: ""
      }]);

      configuracoes.forEach((configuracao) => {
        if(configuracao.MODULO == "CHAMADA_TV") {
          if(configuracao.CAMPO == "USUARIOS_CHAMADA_TV") {
            if(configuracao.TEXTO) {
              let usuariosTVs = JSON.parse(window.b64DecodeUnicode(configuracao.TEXTO));
        
              usuariosTVs.forEach((usuarioTV) => {
                this.opcoesTVs.push({
                  value: usuarioTV.DESCRICAO, 
                  text: usuarioTV.DESCRICAO
                });
              });
            }
          }
        } else if(configuracao.MODULO == "TOTEM") {
          if(configuracao.CAMPO == "VISUALIZA_FILA_ESPERA_TOTEM") {
            if(configuracao.CONTEUDO == "1") {
              this.visualizaFilaEsperaTotem = true;
            } else {
              this.visualizaFilaEsperaTotem = false;
            }
          }
        }
      });
    }, 
    isItemBusy(item) {
      return Boolean(
        item.chamando || item.descartando
      );
    }, 
    formatDate(value) {
      if (!value) {
        return "";
      }

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return value;
      }

      return new Intl.DateTimeFormat(
        "pt-BR", 
        {
          day: "2-digit", 
          month: "2-digit", 
          hour: "2-digit", 
          minute: "2-digit"
        }
      ).format(date);
    }, 
    buscar() {
      this.checkSenhasTotemPendente = setTimeout(async () => {
        this.$socket.emit("entrarNosPainesSenhas", {
          ID_EMITENTE_ML: this.idEmitenteML
        });

        await this.verificarSenhasTotemPendente();
        await this.$nextTick();
        this.buscar();
      }, 15000);
    }, 
    async refresh() {
      this.clearTimer();
      await this.$nextTick();
      await this.verificarSenhasTotemPendente();
      await this.$nextTick();
      this.startTimer();
    }, 
    resetTimer() {
      this.clearTimer();
      this.startTimer();
    }, 
    startTimer() {
      this.buscar();
    }, 
    clearTimer() {
      if(this.checkSenhasTotemPendente) {
        clearInterval(this.checkSenhasTotemPendente);
      }
    }, 
    async chamar(senhaTotemPendente) {
      if(!this.tvChamada) {
        this.$swal({
          icon: "error", 
          text: "Selecione a TV para onde deseja enviar a chamada.", 
          timer: 3000, 
          timerProgressBar: true
        });

        return;
      }

      await this.chamarSenhaTotemPendente({
        ID_TOTEM_SENHA: senhaTotemPendente.ID_TOTEM_SENHA, 
        LOCALIZACAO_FISICA: this.localizacaoFisica
      });

      this.atualizarSenhaChamando({
        ID_TOTEM_SENHA: senhaTotemPendente.ID_TOTEM_SENHA, 
        USUARIO: this.usuario, 
        LOCALIZACAO_FISICA: this.localizacaoFisica
      });

      this.$socket.emit("painelSenha", {
        ID_TOTEM_SENHA: senhaTotemPendente.ID_TOTEM_SENHA, 
        USUARIO: this.usuario, 
        LOCALIZACAO_FISICA: this.localizacaoFisica
      });

      if(!this.localizacaoFisica) {
        await this.informarLocalizacaoFisica();
        await this.$nextTick();
      }

      this.$socket.emit("chamadaNaTV", {
        ID_EMITENTE_ML: this.idEmitenteML, 
        TIPO: "DIRETO_TV", 
        SENHA: senhaTotemPendente.SENHA, 
        NOME_TV: this.tvChamada, 
        PACIENTE: senhaTotemPendente.PACIENTE ? senhaTotemPendente.PACIENTE : "", 
        ID_LOCAL: senhaTotemPendente.ID_LOCAL ? senhaTotemPendente.ID_LOCAL : "", 
        LOCAL: this.localizacaoFisica, 
        MEDICO: "", 
        ORIGEM_CHAMADA: ""
      });
      
      this.$swal({
        icon: "success",
        text: "Chamada enviada para " + this.tvChamada + ".",
        timer: 3000,
        timerProgressBar: true
      });

      await this.$nextTick();

      this.refresh();
    }, 
    async descartar(senhaTotemPendente) {
      await this.descartarSenhaTotemPendente(senhaTotemPendente.ID_TOTEM_SENHA);
      this.atualizarSenhaDescartando(senhaTotemPendente.ID_TOTEM_SENHA);
      this.$socket.emit("painelSenhaDescartando", senhaTotemPendente.ID_TOTEM_SENHA);
      this.refresh();
    }, 
    rotaPermitida() {
      if(["totemPaciente", "chamadaNaTV"].includes(this.$route.name)) {
        return false;
      } else {
        return true;
      }
    }, 
    toggleFila(filaNome) {
      this.selecionarFilaSenhaTotem(filaNome);
    }
  }
};
</script>

<style scoped>
.refresh-button {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  padding: 0;

  color: #657286;
  background: transparent;

  border: 0;
  border-radius: 8px;

  cursor: pointer;
}

.refresh-button:hover:not(:disabled) {
  color: #0058b7;
  background: #eef4ff;
}

.refresh-button:disabled {
  cursor: default;
  opacity: 0.6;
}

.refresh-button svg {
  width: 17px;
  height: 17px;
}

.refresh-button--loading svg {
  animation: rotate 1s linear infinite;
}

/* States */

.panel-state {
  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;

  min-height: 190px;

  padding: 30px;

  gap: 12px;

  color: #758196;

  text-align: center;

  font-size: 13px;
}

.panel-state--empty strong {
  color: #2a3548;

  font-size: 14px;
}

.panel-state--empty > span {
  max-width: 270px;

  line-height: 1.5;
}

.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 50px;
  height: 50px;

  color: #20945b;
  background: #eaf8f0;

  border-radius: 15px;
}

.empty-icon svg {
  width: 29px;
  height: 29px;
}

/* Lista */

.documents {
  padding: 8px;
}

.document-item {
  padding: 14px;

  background: #ffffff;

  border: 1px solid #e6ebf0;
  border-radius: 11px;

  transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease;
}

.document-item + .document-item {
  margin-top: 8px;
}

.document-item:hover {
  border-color: #d2dae3;

  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.04);
}

.document-item__top {
  display: flex;
  align-items: flex-start;

  gap: 10px;
}

.document-item__icon {
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 0 0 auto;

  width: 36px;
  height: 36px;

  color: #0058b7;
  background: #eef4ff;

  border-radius: 9px;
}

.document-item__icon svg {
  width: 20px;
  height: 20px;
}

.document-item__content {
  flex: 1;

  min-width: 0;
}

.document-item__title {
  overflow: hidden;

  color: #1e293b;

  font-size: 13px;
  font-weight: 700;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-item__patient {
  margin-top: 3px;

  overflow: hidden;

  color: #657286;

  font-size: 12px;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-item__appointment {
  margin-top: 6px;
  color: #2563a6;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.document-item__type {
  flex: 0 0 auto;

  padding: 4px 7px;

  color: #536173;
  background: #f2f5f8;

  border-radius: 6px;

  font-size: 10px;
  font-weight: 700;

  text-transform: uppercase;
}

.document-item__metadata {
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 8px;

  margin-top: 10px;
  padding-top: 9px;

  color: #8490a1;

  border-top: 1px solid #f0f2f5;

  font-size: 10px;
}

.document-item__date {
  flex: 0 0 auto;
}

/* Actions */

.document-item__actions {
  display: flex;
  justify-content: flex-end;

  gap: 7px;

  margin-top: 12px;
}

.action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-height: 34px;

  padding: 0 11px;

  gap: 6px;

  border-radius: 7px;

  cursor: pointer;

  font-size: 11px;
  font-weight: 700;

  transition:
      color 0.15s ease,
      background-color 0.15s ease,
      border-color 0.15s ease;
}

.action-button:disabled {
  cursor: default;
  opacity: 0.55;
}

.action-button svg {
  width: 15px;
  height: 15px;
}

.action-button--discard {
  color: #687588;
  background: #ffffff;

  border: 1px solid #d8dee6;
}

.action-button--discard:hover:not(:disabled) {
  color: #c93434;
  background: #fff5f5;

  border-color: #f1bcbc;
}

.action-button--sign {
  color: #ffffff;
  background: #0058b7;

  border: 1px solid #0058b7;
}

.action-button--sign:hover:not(:disabled) {
  background: #0048b7;
  border-color: #0048b7;
}

/* Footer */

.panel-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;

  color: #788497;

  font-size: 10px;
}

.panel-footer__sync {
  color: #0058b7;
}

/* Loading */

.spinner,
.button-spinner {
  border-style: solid;
  border-radius: 50%;

  animation: rotate 0.8s linear infinite;
}

.spinner {
  width: 23px;
  height: 23px;

  border-width: 2px;
  border-color: #d5deea;
  border-top-color: #0058b7;
}

.button-spinner {
  width: 13px;
  height: 13px;

  border-width: 2px;
  border-color: rgba(255,255,255,.4);
  border-top-color: #ffffff;
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}
</style>
